import React from 'react';
import SectionLayout from 'atoms/Layout/Section/SectionLayout';
import WhyMightyTextBlock from 'organisms/Homepage/WhyMightyTextBlock/WhyMightyTextBlock';

const WhyMighty = (): JSX.Element => (
  <SectionLayout
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    maxWidth='width-3xl'
  >
    <WhyMightyTextBlock />
  </SectionLayout>
);

export default WhyMighty;
